module.exports = __webpack_public_path__ + "img/m_logo.b25a75d9.png";